export default __webpack_public_path__ + "img/b33889f81518f5a6813999bae2889b56.png";